import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CalculatedRouteModalComponent } from './calculated-route-modal.component';

@Injectable({
  providedIn: 'root'
})
export class CalculatedRouteModalService {
  private dialogRef: MatDialogRef<CalculatedRouteModalComponent>;

  constructor(private dialog: MatDialog) {}

  openDialog(): MatDialogRef<CalculatedRouteModalComponent> {
    this.dialogRef = this.dialog.open(CalculatedRouteModalComponent);
    return this.dialogRef;
  }

  closeDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}